import React from 'react';
import Navbar from '../components/shared/Navbar';

export default function GaleryPage(){

    return(
        <div class="GaleryPage">
            <Navbar/>
            <h1>Hola</h1>
        </div>
    )
}